<div class="backgroundDark">
    <h2 mat-dialog-title class="marginBottom0" fxFlex>Confirm Date of Birth</h2>
    <button mat-icon-button fxLayoutAlign="end center" (click)="close()" tabindex="-1">
        <mat-icon aria-label="Close" class="headerIconButton">close</mat-icon>
    </button>
</div>

<mat-dialog-content style="max-height: 95%; padding: 0 !important;">
    <form [formGroup]="registerDobFormGroup" (ngSubmit)="checkDateOfBirth()" novalidate autocomplete="off">
        <mat-card class="mainStepperCard">
            <mat-card-content class="mainStepperCardContent" style="background: #f2f2f2;">
                <mat-card class="stepperCard">
                    <mat-card-header>
                        <mat-card-title></mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <div fxLayout="column">
                            <div fxLayout="row" fxLayoutGap="20px">
                                <mat-form-field fxFlex="100%" appearance="legacy">
                                    <input matInput [matDatepicker]="dateOfBirth" placeholder="Date of Birth (mm/dd/yyyy)" formControlName="dateOfBirth" required #dateOfBirthInput (click)="dateOfBirth.open()">
                                    <mat-datepicker-toggle matSuffix [for]="dateOfBirth"></mat-datepicker-toggle>
                                    <mat-datepicker #dateOfBirth [touchUi]="isMobile"></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div fxLayout="row" fxLayoutGap="20px">
                                <mat-slide-toggle formControlName="isGraduateStudent" fxFlex="100%" fxFlex.lt-lg="100%">Are you applying for a graduate program?</mat-slide-toggle>
                                <!--<mat-checkbox formControlName="isGraduateStudent" fxFlex="100%" class="marginTop10" color="primary" fxFlex.lt-lg="100%">Are you applying for a graduate program?</mat-checkbox>-->
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </mat-card-content>
            <mat-divider class="dividerColor"></mat-divider>
            <mat-card-actions fxLayoutAlign="end center">
                <button class="mat-raised-button dialogActionButton" mat-button (click)="close()" type="button">Cancel</button>
                <button class="mat-raised-button dialogActionButton" mat-button color="primary" type="submit" [disabled]="registerDobFormGroup.invalid">Confirm</button>
            </mat-card-actions>
        </mat-card>
    </form>
</mat-dialog-content>
